/*
 * Bögreteszt navigáció - egy kiválasztott szempont alapján pontos Shopify-kollekciót nyit.
 * Készítette: Varga Bálint | branch: dev/balint | 2026-08-27
 * Módosítva: Varga Bálint | branch: dev/balint | 2026-08-27 - aktív választás és dinamikus CTA-visszajelzés
 */

(() => {
  const recipientRoutes = {
    anyukanak: '/collections/ajandek-bogrek-noknek',
    apukanak: '/collections/ajandek-bogrek-ferfiaknak',
    paromnak: '/collections/ajandek-bogrek-paroknak',
    pedagogusnak: '/collections/ajandek-bogrek-tanaroknak-ovonoknek',
    gyereknek: '/collections/ajandek-bogrek-gyerekeknek',
    allatbaratnak: '/collections/ajandek-bogrek-allatbaratoknak'
  };

  const occasionRoutes = {
    szuletesnapra: '/collections/ajandek-bogrek-szuletesnapra',
    nevnapra: '/collections/ajandek-bogrek-nevnapra',
    'anyak-napjara': '/collections/anyak-napi-bogrek',
    'apak-napjara': '/collections/ajandek-bogrek-apak-napjara',
    karacsonyra: '/collections/karacsonyi-termekek',
    ballagasra: '/collections/ajandekok-ballagasra'
  };

  const styleRoutes = {
    viragos: '/collections/viragos-bogrek-ajandek',
    allatos: '/collections/allatos-bogre',
    'szemelyre-szabott': '/collections/szemelyre-szabott-ajandekok'
  };

  const routeFor = (select) => {
    const kind = select.dataset.quizKind;
    if (['recipient', 'smile'].includes(kind)) return recipientRoutes[select.value];
    if (['occasion', 'heart'].includes(kind)) return occasionRoutes[select.value];
    return styleRoutes[select.value];
  };

  const initializeQuiz = (form) => {
    if (form.dataset.quizReady === 'true') return;
    form.dataset.quizReady = 'true';

    const selects = [...form.querySelectorAll('[data-quiz-kind]')];
    const styleSelect = selects.find((select) => ['style', 'leaf'].includes(select.dataset.quizKind));
    const button = form.querySelector('.bm-mug-quiz__button');
    const defaultButtonLabel = button?.dataset.defaultLabel || button?.textContent.trim() || '';

    if (styleSelect) {
      [...styleSelect.options].forEach((option) => {
        if (option.value === '') return;
        const isSupported = Boolean(styleRoutes[option.value]);
        option.hidden = !isSupported;
        option.disabled = !isSupported;
      });
    }

    const updateVisualState = () => {
      const selected = selects.find((select) => select.value !== '');

      selects.forEach((select) => {
        const choice = select.closest('.bm-mug-quiz__choice');
        choice?.classList.toggle('is-active', select === selected);
        choice?.classList.toggle('is-muted', Boolean(selected) && select !== selected);
      });

      if (button) {
        const selectedLabel = selected?.selectedOptions[0]?.textContent.trim();
        button.textContent = selectedLabel ? `${defaultButtonLabel} · ${selectedLabel}` : defaultButtonLabel;
      }
    };

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        selects.forEach((otherSelect) => {
          otherSelect.setCustomValidity('');
          if (select.value !== '' && otherSelect !== select) otherSelect.value = '';
        });
        updateVisualState();
      });
    });

    updateVisualState();

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const selected = selects.find((select) => select.value !== '');

      if (!selected) {
        const validationTarget = selects[0];
        if (!validationTarget) return;
        validationTarget.setCustomValidity(form.dataset.validationMessage || 'Válassz egy keresési szempontot.');
        validationTarget.reportValidity();
        return;
      }

      const destination = routeFor(selected) || form.dataset.fallbackUrl || '/collections/all';
      window.location.assign(destination);
    });
  };

  const initializeAll = (root = document) => root.querySelectorAll('[data-bm-mug-quiz]').forEach(initializeQuiz);

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
